import { steps } from './steps'
import { useOnBoard } from '../../../Onboard/useOnBoard'

export const useGeneralSearchOnBoarding = ({ enabled }) =>
  useOnBoard({ storageKey: 'onboarding_general_search', steps, enabled })
